module.exports = __webpack_public_path__ + "protaxi.jpg?f3fb4ae42925319305deccf294a970a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/protaxi.jpg
// module id = 748
// module chunks = 0